import { AudioElementClock } from './AudioElementClock';
export class MediaTrackPlayer extends AudioElementClock {
    constructor(url, audioContext) {
        super(new Audio(url), audioContext, 0);
        this.audio.crossOrigin = 'anonymous';
        const source = audioContext.createMediaElementSource(this.audio);
        source.connect(audioContext.destination);
    }
    close() {
        this.audio.currentTime = 0;
        this.audio.src = '';
        super.close();
    }
}
//# sourceMappingURL=MediaTrackPlayer.js.map